import React from "react";
import { Button } from "@mui/material";
import { indianStates } from "../../config/constantselections";

const GenerateLabel = ({ selectedSales }) => {
  const getStateLabel = (value) => {
    const state = indianStates.find((state) => state.value === value);
    return state ? state.label : "";
  };
  const handleGenerateLabel = () => {
    if (selectedSales.length === 0) {
      alert("Please select at least one shipment to generate a label.");
      return;
    }

    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document.write(`
      <html><head><title>Shipment Labels</title><style>
        body { font-family: Work Sans, sans-serif; margin: 20px; font-size: 18px; }
        .label-container { display: grid; grid-template-columns: repeat(2, 50%); column-gap: 20px; row-gap: 20px; page-break-inside: avoid; }
        .label { border: 1px solid #000; padding: 10px; box-sizing: border-box; page-break-inside: avoid; }
        .from-address { font-size: 13px; text-align: left; margin-bottom: 8px; }
        .to-address { font-size: 24px; text-align: left; }
        .address-line { margin: 0; padding: 0; }
        .label-title { font-size: 20px; font-weight: bold; }
      </style></head><body>
      <div class="label-container">
    `);

    selectedSales.forEach((sale) => {
      printWindow.document.write(`
        <div class="label">
          <div class="from-address">
            <p class="label-title">FROM:</p>
            <p class="address-line">ANJANA ASOK</p>
            <p class="address-line">KERA 135, HARISMRITHI LANE,</p>
            <p class="address-line">KANJIRAMPARA, TRIVANDRUM,</p>
            <p class="address-line">KERALA, PIN 695030</p>
            <p class="address-line">PH: 7907448913</p>
          </div>
          <div class="to-address">
            <p class="label-title">TO:</p>
            <p class="address-line">${sale.name}</p>
            <p class="address-line">${sale.buyer_details.replace(/\n/g, "<br/>")}</p>
            <p class="address-line">Pin Code: ${sale.pincode}</p>
            <p class="address-line"> ${getStateLabel(sale.state) || "N/A"}</p>
            <p class="address-line">PH: ${sale.phone_number}</p>
          </div>
        </div>
      `);
    });

    printWindow.document.write("</div></body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <Button variant="contained" color="primary" onClick={handleGenerateLabel}>
      Generate Label
    </Button>
  );
};

export default GenerateLabel;
